import { kebabCase } from 'lodash-es';

export const normalizeJobsParams = (value: string | null | undefined) =>
  value ? kebabCase(value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) : '';
